import { Box, type BoxProps } from "@chakra-ui/react";
import {
  MDXEditor,
  headingsPlugin,
  imagePlugin,
  linkDialogPlugin,
  linkPlugin,
  listsPlugin,
  quotePlugin,
  thematicBreakPlugin,
} from "@mdxeditor/editor";
import "@mdxeditor/editor/style.css";

import styles from "./Markdown.module.css";

export const EquidefiMarkdown: React.FC<BoxProps & { children: string | null | undefined; darkTheme?: boolean }> = ({
  children,
  darkTheme,
  ...rest
}) => {
  const markdown = children ?? "";

  return (
    <Box __css={{ "& p:last-of-type": { mb: 0 } }} {...rest}>
      <MDXEditor
        key={markdown}
        markdown={markdown}
        readOnly
        contentEditableClassName={styles.markdownContent}
        className={darkTheme ? "dark-theme" : ""}
        plugins={[
          headingsPlugin(),
          listsPlugin(),
          quotePlugin(),
          thematicBreakPlugin(),
          linkPlugin(),
          linkDialogPlugin(),
          imagePlugin(),
        ]}
      />
    </Box>
  );
};
